export default {
  gnb: {
    oneToOne: "1:1 문의",
    myInquiry: "나의 문의 내역",
    faq: "FAQ",
    notice: "공지사항",
  },
  table: {
    filter: "필터",
    searchText: "검색어",
    enterSearchKeyword: "검색 키워드를 입력하세요",
    sort: "정렬",
    ascending: "오름차순",
    descending: "내림차순",
    noSort: "정렬 안함",
    clear: "초기화",
    apply: "적용",
    filterBy: "필터 조건",
    all: "전체",
    noData: "데이터 없음",
  },
  pagination: {
    pageSize: "페이지 크기:",
    page: "페이지",
    firstPage: "첫 페이지",
    previousPage: "이전 페이지",
    nextPage: "다음 페이지",
    lastPage: "마지막 페이지",
    total: "총",
    entries: "항목",
  },
  login: {
    links: {
      noAccount: "계정이 없다면",
    },
    error: {
      noId: "ID를 입력하세요",
      noPassword: "Password를 입력하세요",
      changePassword: "비밀번호를 변경하세요",
      periodPassed: "비밀번호 변경 기간(90일)이 지났습니다. 비밀번호를 변경하세요",
      loginFailed: "로그인을 5회 이상 실패하였습니다.<BR/> 관리자에게 문의하세요",
      noUser: "일치하는 사용자 정보가 없습니다.",
    },
    changePassword: {
      notification: "비밀번호는 대문자, 소문자, 특수문자 포함 8 ~ 16 자리가 입력되어 합니다",
      prePassword: "기존 비밀번호",
      password: "비밀번호",
      confirm: "비밀번호 확인",
      change: "변경",
      cancel: "취소",
      error: {
        different: "암호가 서로 다릅니다.",
        overNumber: "암호는 8자 이상이어야 합니다.",
        underNumber: "암호는 16자 이하여야 합니다.",
        atleastNumber: "최소한 하나의 숫자를 제공해야 합니다.",
        capital: "하나 이상의 대문자를 제공합니다.",
        small: "하나 이상의 소문자를 제공합니다.",
        special: "하나 이상의 특수문자를 제공합니다.",
        general: "비밀번호 변경 중 오류가 발생했습니다. 다시 시도해 주세요.",
      },
    },
  },
  signup: {
    title: "회원가입",
    labels: {
      userId: "User ID",
      password: "비밀번호",
      confirmPassword: "비밀번호 확인",
      language: "언어",
      role: "권한",
      site: "사이트",
    },
    placeholders: {
      selectLanguage: "언어를 선택하세요",
      selectRole: "권한을 선택하세요",
      selectSite: "사이트를 선택하세요",
    },
    links: {
      haveAccount: "계정이 있다면",
    },
    validation: {
      password: {
        required: "비밀번호를 입력해주세요.",
        minLength: "비밀번호는 8자 이상이어야 합니다.",
        maxLength: "비밀번호는 16자 이하여야 합니다.",
        requireNumber: "비밀번호에 숫자가 포함되어야 합니다.",
        requireUppercase: "비밀번호에 대문자가 포함되어야 합니다.",
        requireLowercase: "비밀번호에 소문자가 포함되어야 합니다.",
        requireSpecialChar: "비밀번호에 특수문자가 포함되어야 합니다.",
      },
      confirmPassword: {
        required: "비밀번호 확인을 입력해주세요.",
        mismatch: "비밀번호가 일치하지 않습니다.",
      },
    },
    messages: {
      signupSuccess: "회원가입이 완료되었습니다. 로그인해주세요.",
      signupError: "회원가입에 실패했습니다.",
      signupErrorGeneral: "회원가입 중 오류가 발생했습니다.",
      allFieldsRequired: "모든 필드를 올바르게 입력해주세요.",
    },
  },
  selectSite: {
    title: "사이트 선택",
    subtitle: "사용할 사이트를 선택해주세요",
    notice: "⚠️ 사이트를 선택해야 다른 메뉴에 접근할 수 있습니다",
    loading: "사이트 목록을 불러오는 중...",
    error: "사이트 목록을 불러오는데 실패했습니다.",
    selectError: "사이트 선택 중 오류가 발생했습니다.",
  },
  home: {
    title: "전체현황",
    summary: "요약",
    description: "로봇 시스템의 전체 현황을 모니터링합니다.",
    robotStatus: {
      title: "로봇 상태",
      activeRobots: "활성 로봇",
      waitingRobots: "대기 로봇",
      run: "작동",
      idle: "대기",
      error: "오류",
      charging: "충전",
    },
    serviceStatus: {
      title: "서비스 현황",
      running: "실행 중",
      waiting: "대기 중",
    },
    jobStatus: "작업 현황",
    todayJob: "오늘 작업 건 수",
    avgJobTime: "평균 작업 시간",
    failJob: "실패 건수",
    job: "건",
    sec: "초",
    alarmLogTitle: "알림 및 경고 로그",
    priority: "중요도",
    status: "상태",
    totalDropDown: "전체",
    alarmColumns: {
      priority: "중요도",
      eqipmentName: "로봇명",
      desc: "내용",
      occurTime: "발생 시각",
      releaseTime: "해제 시각",
      position: "위치",
    },
    error: {
      siteIdRequired: "사이트 ID가 필요합니다",
      robotTypeCodeRequired: "로봇 타입 코드가 필요합니다",
      fetchRobotSummaryByStatus: "상태별 로봇 요약 조회 중 오류가 발생했습니다",
      fetchRobotSummaryByType: "타입별 로봇 요약 조회 중 오류가 발생했습니다",
      fetchRobotJobs: "로봇 작업 조회 중 오류가 발생했습니다",
      fetchRobotImage: "로봇 이미지 조회 중 오류가 발생했습니다",
      fetchAlarmLogs: "알람 로그 조회 중 오류가 발생했습니다",
      fetchAlarmStatusCode: "알람 상태 코드 조회 중 오류가 발생했습니다",
      fetchActiveAlarmCount: "활성 알람 수 조회 중 오류가 발생했습니다",
      downloadAlarmReport: "알람 리포트 다운로드 중 오류가 발생했습니다",
      invalidBlob: "잘못된 파일 형식을 받았습니다",
    },
  },
  logout: {
    confirm: "로그아웃 하시겠습니까?",
    description: "로그아웃하면 현재 작업이 저장되지 않을 수 있습니다.",
    success: "로그아웃되었습니다.",
    error: "로그아웃 중 오류가 발생했습니다.",
  },

  messages: {
    removeNotAllowed: "삭제 불가",
    overlayNoRowsTemplate: "표시할 데이터가 없습니다.",
    loading: "로딩 중...",
    moveBin: "빈이 이동중 입니다.",
    deleteConfirm: "삭제하시겠습니까?",
    bulkDeleteConfirm: "선택된 {number} 항목을 삭제하시겠습니까?",
    saveConfirm: "저장하시겠습니까?",
    duplication: "중복된 값이 있습니다.",
    changeConfirm: "편집 및 변경내역을 취소하시겠습니까?",
    save: "저장되었습니다.",
    cancel: "취소하였습니다.",
    delete: "삭제되었습니다.",
    notSelected: "처리할 데이터가 없습니다.",
    resend: " 건 재전송 되었습니다.",
    release: " 건 해제 되었습니다. ",
    sendConfirm: "전송 하시겠습니까?",
    sendComplete: "전송 하였습니다.",
    sendCancelConfirm: "전송취소 하시겠습니까?",
    sendCancelComplete: "전송취소 하였습니다.",
    sendStockAdjustment: "재고 조정을 하시겠습니까?",
    sendStockTaking: "재고 실사 전송을 하시겠습니까?",
    sendStockTakingCancel: "실사 취소를 하시겠습니까?",

    createSuccess: "생성되었습니다.",
    createFailed: "생성에 실패했습니다.",
    createError: "생성 중 오류가 발생했습니다.",
    editSuccess: "수정되었습니다.",
    editFailed: "수정에 실패했습니다.",
    editError: "수정 중 오류가 발생했습니다.",
    deleteSuccess: "삭제되었습니다.",
    deleteFailed: "삭제에 실패했습니다.",
    noSelectedItems: "선택된 항목이 없습니다.",
    bulkDeleteSuccess: "{number} 선택된 항목이 성공적으로 삭제되었습니다.",
    bulkDeleteFailed: "일괄 삭제에 실패했습니다.",
    exportSuccess: "내보내기가 완료되었습니다.",
    exportFailed: "내보내기에 실패했습니다.",

    // 공통 유효성 검사 메시지
    validation: {
      required: "필수 입력 항목입니다.",
      invalidFormat: "올바른 형식이 아닙니다.",
      minLength: "최소 {min}자 이상 입력해주세요.",
      maxLength: "최대 {max}자까지 입력 가능합니다.",
      email: "올바른 이메일 형식이 아닙니다.",
      phone: "올바른 전화번호 형식이 아닙니다.",
      number: "숫자만 입력 가능합니다.",
      positiveNumber: "양수만 입력 가능합니다.",
      date: "올바른 날짜 형식이 아닙니다.",
      time: "올바른 시간 형식이 아닙니다.",
      lengthExceeded: "입력이 최대 길이 {max}자를 초과했습니다.",
      lengthTooShort: "최소 {min}자 이상 입력해주세요.",
    },

    // 공통 에러 메시지
    errors: {
      network: "네트워크 오류가 발생했습니다.",
      server: "서버 오류가 발생했습니다.",
      system: "시스템 오류가 발생했습니다. 페이지를 새로고침해주세요.",
      unauthorized: "권한이 없습니다.",
      forbidden: "접근이 금지되었습니다.",
      notFound: "요청한 리소스를 찾을 수 없습니다.",
      timeout: "요청 시간이 초과되었습니다.",
      unknown: "알 수 없는 오류가 발생했습니다.",
      validation: "입력 데이터가 올바르지 않습니다.",
      duplicate: "중복된 데이터입니다.",
      notExist: "존재하지 않는 데이터입니다.",
      loadDataError: "데이터를 불러오는데 실패했습니다.",
    },

    // 공통 성공 메시지
    success: {
      save: "저장되었습니다.",
      update: "수정되었습니다.",
      delete: "삭제되었습니다.",
      create: "생성되었습니다.",
      send: "전송되었습니다.",
      complete: "완료되었습니다.",
      success: "성공했습니다.",
    },

    // 페이지네이션 관련 메시지
    pagination: {
      firstPage: "첫 페이지",
      previousPage: "이전 페이지",
      nextPage: "다음 페이지",
      lastPage: "마지막 페이지",
    },
    // 검색 관련 메시지
    search: {
      searchBy: "로 검색",
      search: "검색",
    },
    // API 관련 메시지
    apiSuccess: "처리가 완료되었습니다.",
    apiError: "오류가 발생했습니다.",
    apiNetworkError: "네트워크 오류가 발생했습니다.",
    apiTimeout: "요청 시간이 초과되었습니다.",
    apiUnauthorized: "권한이 없습니다.",
    apiSessionTimeout: "세션이 타임아웃되었습니다. 다시 로그인해주세요.",
    apiNotFound: "요청한 리소스를 찾을 수 없습니다.",
    apiServerError: "서버 오류가 발생했습니다.",
    apiValidationError: "입력 데이터가 올바르지 않습니다.",
    networkError: "네트워크 연결을 확인해주세요.",
    // 질문 팝업 메시지
    editConfirm: "수정하시겠습니까?",
    updateConfirm: "업데이트하시겠습니까?",
    createConfirm: "생성하시겠습니까?",
    importConfirm: "데이터를 가져오시겠습니까?",
    exportConfirm: "데이터를 내보내시겠습니까?",
    resetConfirm: "초기화하시겠습니까?",
    refreshConfirm: "새로고침하시겠습니까?",
    closeConfirm: "닫으시겠습니까?",
    cancelConfirm: "취소하시겠습니까?",
    proceedConfirm: "계속 진행하시겠습니까?",
    stopConfirm: "중지하시겠습니까?",
    retryConfirm: "다시 시도하시겠습니까?",
  },
  // 공통 액션 (모든 화면에서 사용)
  common: {
    notAvailable: "해당없음",
    actions: {
      back: "뒤로가기",
      home: "홈으로",
      refresh: "새로고침",
      settings: "설정",
      help: "도움말",
    },
    station: {
      title: "Station 관리",
      lastUpdate: "마지막 동기화",
      stationSync: "로봇 정보 동기화",
      stationList: "스테이션 현황",
      deRegistration: "등록해제",
      robotGroup: "로봇",
      stationType: "상태",
      stationName: "스테이션명",
      position: "위치",
      regisTime: "등록시간",
      countOfService: "연결 서비스 수",
      useYn: "사용여부",
      actions: "작업",
      createdAt: "생성일",
      updatedAt: "수정일",
      unregisStation: "미등록 스테이션을 등록해주세요",
      unregisStationTitle: "미등록 스테이션",
      subTitle: "로봇이 인식한 스테이션 중 아직 관제 플랫폼에 등록되지 않은 항목을 확인할 수 있습니다.",
      regisStation: "스테이션 등록",
      subTitle2: "좌측 목록에서 스테이션을 선택하여 플랫폼에서 사용할 이름과 용도를 등록해 주세요.",
      subTitle3: "등록할 스테이션을 선택해주세요.",
      subTitle4: '스테이션을 "{stationName}" 등록하시겠습니까?',
      subTitle5: "오류 입력",
      subTitle6: "스테이션이 성공적으로 등록되었습니다.",
      subTitle7: "스테이션 등록에 실패했습니다. 다시 시도해 주세요.",
      regisSuccess: "스테이션이 성공적으로 등록되었습니다.",
      regisFail: "등록 실패",
      stationGroup: "스테이션 그룹",
      stationGroupName: "스테이션 그룹명",
      creatStationGroupSuccess: "스테이션 그룹이 성공적으로 추가되었습니다.",
      creatStationGroupFailed: "추가에 실패했습니다.",
      register: "스테이션 등록",
      createStationGroup: "스테이션 그룹 추가",
      confirmRegister: "등록 확인",
      confirmDeregistration: '스테이션 "{stationName}" 의 등록을 해제하시겠습니까?',
      deregisterSuccess: "스테이션이 성공적으로 등록 해제되었습니다.",
      deregisterError: "스테이션 등록 해제에 실패했습니다.",
      success: "성공",
      ok: "OK",
      total: "전체",
      syncSuccess: "스테이션 동기화가 성공적으로 완료되었습니다.",
      syncError: "스테이션 동기화에 실패했습니다. 다시 시도해 주세요.",
      updateSuccess: "스테이션 정보가 성공적으로 수정되었습니다.",
      updateError: "수정에 실패했습니다.",
      deleteConfirm: "스테이션을 삭제하시겠습니까?",
      deleteSuccess: "스테이션이 성공적으로 삭제되었습니다.",
      deleteError: "삭제에 실패했습니다.",
      editStation: "스테이션 수정",
      latitude: "위도 좌표",
      longitude: "경도 좌표",
      errors: {
        stationGroupRequired: "스테이션 그룹을 선택해 주세요.",
        stationTypeRequired: "스테이션 유형을 선택해 주세요.",
        stationNameRequired: "스테이션명을 입력해 주세요.",
        stationNameExist: "스테이션명이 이미  존재합니다.",
      },
      input: {
        stationGroupId: "스테이션 그룹 ID 입력",
        stationGroupName: "스테이션 그룹명 입력",
      },
      placeholders: {
        latitude: "위도 입력 (-90 ~ 90)",
        longitude: "경도 입력 (-180 ~ 180)",
        useYn: "사용 여부 선택",
      },
      options: {
        useYn: {
          Y: "사용",
          N: "미사용",
        },
      },
    },
    options: {
      useYn: {
        all: "모두",
        yes: "사용",
        no: "사용 안 함",
      },
    },
  },
  // 404 페이지 관련 메시지
  404: {
    home: {
      confirm: "홈으로 이동하시겠습니까?",
      success: "홈으로 이동합니다.",
      error: "홈으로 이동할 수 없습니다.",
    },
    // 권한 부족 관련 메시지 추가
    permission: {
      denied: "해당 메뉴에 대한 접근 권한이 없습니다.",
      requiredRoles: "필요한 권한: {roles}",
      currentRole: "현재 권한: {role}",
      contactAdmin: "관리자에게 문의하세요.",
    },
    // 일반 404 메시지
    general: {
      pageNotFound: "페이지를 찾을 수 없습니다.",
      description: "요청하신 페이지가 존재하지 않습니다.",
      goHome: "메인화면으로 이동",
    },
  },
  // 권한 관련 메시지
  permissions: {
    accessDenied: "접근이 거부되었습니다.",
    insufficientPrivileges: "권한이 부족합니다.",
    menuAccessDenied: "해당 메뉴에 접근할 수 없습니다.",
    roleRequired: "필요한 역할: {roles}",
    contactAdministrator: "시스템 관리자에게 문의하세요.",
    unauthorizedAccess: "인증되지 않은 접근입니다.",
  },
  // 팝업 관련 메시지
  popup: {
    confirm: {
      title: "확인",
      message: "계속 진행하시겠습니까?",
      yes: "예",
      no: "아니오",
      ok: "확인",
      cancel: "취소",
    },
    error: {
      title: "오류",
      general: "오류가 발생했습니다.",
      network: "네트워크 오류가 발생했습니다.",
      server: "서버 오류가 발생했습니다.",
      permission: "권한이 없습니다.",
      validation: "입력 데이터가 올바르지 않습니다.",
    },
    success: {
      title: "성공",
      general: "처리가 완료되었습니다.",
      save: "저장되었습니다.",
      update: "수정되었습니다.",
      delete: "삭제되었습니다.",
      create: "생성되었습니다.",
    },
    warning: {
      title: "경고",
      general: "주의가 필요합니다.",
      unsavedChanges: "저장되지 않은 변경사항이 있습니다.",
      confirmAction: "이 작업을 계속 진행하시겠습니까?",
    },
  },
  // Tooltip messages
  tooltip: {
    clearAll: "모든 선택 항목 지우기",
    clearSearch: "검색 지우기",
  },
  labels: {
    sir: "님",
    selectTenant: "Tenant를 선택하세요",
    selectCenter: "Center를 선택하세요",
    list: "리스트",
    portListInform: "(Port는 각 Center에서 관리하세요)",
    menu: "메뉴",
    favMenu: "즐겨찾기",

    // Multiselect
    pressEnter: '"{query}"를 추가하려면 Enter 키를 누르세요',
    noResults: "결과가 없습니다",
    startTyping: "검색하려면 입력을 시작하세요...",
  },
  buttons: {
    add: "+",
    remove: "-",
    defaultConfirm: "확인",
    defaultCancel: "취소",
    save: "저장",
    search: "조회",
    send: "전송",
    sendCancel: "전송취소",
    downloadExcel: "엑셀 다운로드",
    uploadExcel: "엑셀 임포트",
    login: "로그인",
    loggingIn: "로그인 중...",
    logout: "로그아웃",
    signup: "회원가입",
    signingUp: "회원가입 중...",
    main: "메인화면",
    refresh: "새로고침",
    delete: "DEL",
    detail: "상세보기",
    callBin: "BIN 호출",
    releaseBin: "BIN 반환",
    release: "해제",
    resend: "재전송",
    deleteRow: "삭제",
    expandAll: "전체펼침",
    collapseAll: "전체닫힘",
    yes: "예",
    no: "아니오",
    defaultClose: "닫기",
    downloadExcelAsync: "엑셀 다운로드 (A)",
    // 추가 버튼 메시지
    cancel: "취소",
    update: "수정",
    changing: "변경 중...",
    create: "생성",
    edit: "편집",
    close: "닫기",
    back: "뒤로",
    next: "다음",
    previous: "이전",
    reset: "초기화",
    export: "내보내기",
    import: "가져오기",
    select: "선택",
    deselect: "선택 해제",
    deleteSelected: "선택 삭제",
    newAdd: "신규 추가",
    bulkDelete: "일괄 삭제",
    clearAll: "모두 지우기",
  },
  errors: {
    expiredCertification: "인증이 만료되었습니다. 다시 로그인하세요.",
    occurred: "처리 중 에러가 발생하였습니다.",
    unavailableAutostore: "Autostore 사용자가 아닙니다.",
    empty: " 가 입력되지 않았습니다.",
    invalidUrl: " 가 유효한 url이 아닙니다.",
    autostoreWarning: "작업을 시작하거나 메인화면으로 돌아가세요.<br />미작업시 자동 종료됩니다.",
    autostoreQuit: "장시간 사용이 없어 자동 종료 됩니다.",
    autostoreEtcDetail: "상세내용은 500자 이하로 입력하세요.",
    number: " 는 숫자만 입력하세요",
    resendFail: "의 재전송에 실패했습니다.",
    releaseFail: "의 해제에 실패했습니다.",
    date: " 8자리 숫자로 YYYYMMDD 형식으로 입력하세요",
    dateRange: "시작일은 종료일보다 작아야 합니다.",
    excelImport: "엑셀화일이 양식에 맞지 않습니다",
    exceedNumberInnerTab: "탭은 15개 이상 열 수 없습니다",
  },
  comboBox: {
    useOrNot: {
      use: "사용",
      not: "미사용",
    },
    cmptYn: {
      cmpt: "완료",
      not: "미완료",
    },
    abnormalYn: {
      abnormal: "대상",
      normal: "비대상",
    },
    successYn: {
      success: "성공",
      notYet: "미전송",
      error: "에러",
    },
  },
  popups: {
    excel: {
      cancelButton: "아니오",
      warning: "엑셀다운로드 전 화면 조회를 먼저하세요.",
      confirm: "엑셀 다운로드를 하시겠습니까?",
    },
  },
  menus: {
    commonManagement: "공통관리",
    accountManagement: "계정관리",
    userManagement: "계정 관리",
    siteManagement: "사이트 관리",
    zoneManagement: "존 관리",
    codeManagement: "공통코드 관리",
    robotGroupManagement: "로봇 그룹 관리",
    robotManagement: "로봇 관리",
    mapManagement: "맵 관리",
    systemManagement: "시스템관리",
    reportManagement: "리포트관리",
    monitoring: "모니터링",
    settings: "설정",
    cafe: "카페",
    cafeOrderManagement: "카페 주문 관리",
    householdManagement: "입주민관리",
    cafeCalendar: "카페 달력",
    help: "도움말",
    // 추가 메뉴 번역들
    home: "홈",
    dashboard: "대시보드",
    robotControl: "로봇 제어",
    report: "리포트",
    common: "공통",
    serviceManagement: "서비스 관리",
    menuManagement: "메뉴 관리",
    // DB에서 오는 실제 메뉴 이름들 (공백 포함)
    Monitoring: "모니터링",
    "Robot Control": "로봇 제어",
    Report: "리포트",
    Home: "홈",
    Common: "공통",
    Service: "서비스",
    alarmRoleMapping: "알람 역할 매핑",
    "Monthly Report": "월간 리포트",
    "Site Info": "사이트 관리",
    "Robot Group Info": "로봇 그룹 관리",
    "Robot Info": "로봇 관리",
    "Zone Info": "존 관리",
    "Common Code Info": "공통코드 관리",
    "User Info": "계정 관리",
    "Map Info": "맵 관리",
    "Station Info": "스테이션 관리",
    // 추가 메뉴들
    "Menu Management": "메뉴 관리",
    "System Management": "시스템 관리",
    "Account Management": "계정 관리",
    Settings: "설정",
    Help: "도움말",
    Dashboard: "대시보드",
    // 서비스 관련 메뉴들
    "Service Setup": "서비스 등록",
    "Service Execution": "서비스 실행",
    "Patrol Robot": "순찰 로봇",
    "Cleaning Robot": "청소 로봇",
    "Barista Robot": "바리스타 로봇",
    "Carry Robot": "배달 로봇",
    "Service Report": "서비스 리포트",
    "Service Order Report": "서비스 주문 리포트",
    "Robot Alarm Log": "로봇 알람 로그",
    "Household Info": "입주민관리",
    "Cafe Order Info": "카페 주문 정보",
    "Cafe Calendar": "카페 달력",
    // 더 많은 메뉴가 필요하면 여기에 추가
    serviceSetup: "서비스 등록",
    "Phone Number Mapping": "전화번호 매핑",
    "Alarm Role Mapping": "알람 역할 매핑",
  },
  // 모니터링 관련 메시지
  monitoring: {
    title: "통합 모니터링",
    integratedMonitoring: "통합 모니터링",
    total: "전체",
    utilization: "가동률",
    totalRobots: "전체 로봇",
    robotTotal: "로봇",
    statusTotal: "상태",
    searchForRobotName: "로봇 ID를 검색하세요",
    lastUpdate: "마지막 동기화",
    filterTotal: "전체", // Added for filter options
    columns: {
      robot: "로봇ID",
      status: "상태",
      position: "위치",
      battery: "배터리",
      details: "상세보기",
    },
    status: {
      run: "작동",
      idle: "대기",
      error: "오류",
      charge: "충전",
    },
    navigation: {
      home: "Home",
      monitoring: "Monitoring",
      robotControl: "Robot Control",
      report: "Report",
      comon: "Comon",
      service: "Service",
    },
    robotList: "로봇 리스트",
    alarm: "알람",
    map: {
      battery: "배터리",
      details: "상세정보",
      fullScreen: "전체화면",
      reset: "초기 위치",
      showPath: "경로 표시",
      hidePath: "경로 숨김",
      tooltip: {
        robotName: "로봇명",
        type: "종류",
        status: "상태",
        battery: "배터리",
        location: "위치",
        floor: "층",
      },
    },
    robotDetail: {
      button: {
        detail: "상세 제어",
      },
      label: {
        destination: "목적지",
        position: "통신 상태",
        connection: "통신 상태",
        battery: "배터리",
        jobCount: "작업 건수",
        jobProgress: "작업 상태",
        coverage: "주행거리",
        streaming: "영상",
      },
      streaming: {
        clickToStart: "클릭하여 스트리밍 시작",
        retry: "다시 시도",
        screenshot: "스크린샷",
        viewInLargeWindow: "큰 창에서 보기",
      },
    },
  },
  // 사용자 관리 관련 언어팩 통합
  user: {
    management: {
      title: "계정 관리",
      actions: {
        addUser: "사용자 추가",
        editUser: "사용자 수정",
        deleteUser: "사용자 삭제",
        deleteSelected: "선택 삭제",
        bulkDelete: "일괄 삭제",
        export: "내보내기",
        actions: "작업",
      },
      search: {
        userId: "사용자 ID",
        userName: "사용자명",
        userStatusCode: "상태",
      },
      columns: {
        userId: "사용자 ID",
        userName: "사용자명",
        roleId: "권한",
        userStatusCode: "상태",
        createdAt: "등록일",
        updatedAt: "수정일",
        userLanguageCode: "언어",
      },
      status: {
        active: "활성",
        inactive: "비활성",
        suspended: "정지",
      },
      roles: {
        admin: "관리자",
        user: "일반 사용자",
        viewer: "조회자",
        manager: "매니저",
        unspecified: "미지정",
      },
      messages: {
        noSearchResults: "검색 결과가 없습니다.",
        loading: "로딩 중...",
        addSuccess: "계정이 성공적으로 추가되었습니다.",
        addFailed: "추가에 실패했습니다.",
        deleteConfirm: "계정을 삭제하시겠습니까?",
        deleteSuccess: "계정이 성공적으로 삭제되었습니다.",
        deleteFailed: "삭제에 실패했습니다.",
        editSuccess: "계정 정보가 성공적으로 수정되었습니다.",
        editFailed: "수정에 실패했습니다.",
      },
      addModal: {
        title: "계정 추가",
      },
      editModal: {
        title: "계정 수정",
        userNamePlaceholder: "사용자명을 입력하세요",
      },
    },
  },
  // 사이트 관련 메시지
  site: {
    management: {
      title: "사이트 관리",
      actions: {
        addSite: "사이트 추가",
        editSite: "사이트 수정",
        deleteSite: "사이트 삭제",
        deleteSelected: "선택 삭제",
        bulkDelete: "일괄 삭제",
        export: "내보내기",
        actions: "작업",
      },
      search: {
        siteId: "사이트 ID",
        siteName: "사이트명",
        useYn: "사용여부",
      },
      columns: {
        siteId: "사이트 ID",
        siteName: "사이트명",
        siteDescription: "사이트 설명",
        useYn: "사용여부",
        createdAt: "등록일",
        updatedAt: "수정일",
      },
      messages: {
        noSearchResults: "검색 결과가 없습니다.",
        loading: "로딩 중...",
        addSuccess: "사이트가 성공적으로 추가되었습니다.",
        addFailed: "추가에 실패했습니다.",
        editConfirm: "사이트를 수정하시겠습니까?",
        deleteConfirm: "사이트를 삭제하시겠습니까?",
        deleteSuccess: "사이트가 성공적으로 삭제되었습니다.",
        deleteFailed: "삭제에 실패했습니다.",
        editSuccess: "사이트 정보가 성공적으로 수정되었습니다.",
        editFailed: "수정에 실패했습니다.",
      },
      addModal: {
        title: "사이트 추가",
      },
      editModal: {
        title: "사이트 수정",
        siteNamePlaceholder: "사이트명을 입력하세요",
        siteDescriptionPlaceholder: "사이트 설명을 입력하세요",
      },
      options: {
        useYn: {
          Y: "사용",
          N: "미사용",
        },
      },
    },
    change: {
      title: "사이트 변경",
      confirm: "현재 사이트를 변경하시겠습니까?",
      description: "변경 시 사이트 선택 화면으로 이동합니다.",
      change: "변경",
      cancel: "취소",
    },
    selection: {
      title: "사이트 선택",
      description: "사용할 사이트를 선택하세요.",
    },
  },
  // 존 관련 메시지
  zone: {
    management: {
      title: "존 관리",
      actions: {
        addZone: "존 추가",
        editZone: "존 수정",
        deleteZone: "존 삭제",
        deleteSelected: "선택 삭제",
        bulkDelete: "일괄 삭제",
        export: "내보내기",
        actions: "작업",
      },
      search: {
        zoneId: "존 ID",
        siteId: "사이트 ID",
        zoneTypeCd: "존 타입",
        zoneNm: "존명",
        flrNo: "층 번호",
        useYn: "사용여부",
      },
      columns: {
        zoneId: "존 ID",
        siteId: "사이트 ID",
        zoneTypeCd: "존 타입",
        zoneNm: "존명",
        flrNo: "층 번호",
        useYn: "사용여부",
        createdAt: "등록일",
        updatedAt: "수정일",
      },
      messages: {
        loading: "로딩 중...",
        deleteConfirm: "존을 삭제하시겠습니까?",
        deleteSuccess: "존이 성공적으로 삭제되었습니다.",
        deleteFailed: "삭제에 실패했습니다.",
        noSearchResults: "검색 결과가 없습니다.",
        addSuccess: "존이 성공적으로 추가되었습니다.",
        addFailed: "추가에 실패했습니다.",
        editSuccess: "존 정보가 성공적으로 수정되었습니다.",
        editFailed: "수정에 실패했습니다.",
      },
      addModal: {
        title: "존 추가",
      },
      editModal: {
        title: "존 수정",
        siteIdPlaceholder: "사이트 ID를 입력하세요",
        zoneNmPlaceholder: "존명을 입력하세요",
        flrNoPlaceholder: "층 번호를 입력하세요",
      },
      placeholders: {
        zoneId: "존 ID를 입력하세요",
        siteId: "사이트를 선택하세요",
        zoneTypeCd: "존 타입을 선택하세요",
        zoneNm: "존명을 입력하세요",
        flrNo: "층 번호를 입력하세요",
        useYn: "사용 여부를 선택하세요",
      },
      options: {
        useYn: {
          Y: "사용",
          N: "미사용",
        },
        zoneTypeCd: {
          storage: "저장소",
          work: "작업장",
          picking: "피킹존",
          staging: "스테이징",
          cleaning: "청소",
        },
      },
    },
  },
  // 공통코드 관련 메시지
  code: {
    management: {
      title: "공통코드 관리",
      actions: {
        addCode: "코드 추가",
        editCode: "코드 수정",
        deleteCode: "공통코드 삭제",
        deleteSelected: "선택 삭제",
        bulkDelete: "일괄 삭제",
        export: "내보내기",
        actions: "작업",
      },
      search: {
        commonCodeGroup: "코드 그룹",
        commonCode: "공통코드",
        codeName: "코드명",
        useYn: "사용여부",
      },
      columns: {
        commonCodeGroup: "코드 그룹",
        commonCode: "공통코드",
        codeName: "코드명",
        codeDescription: "코드 설명",
        useYn: "사용여부",
        createdAt: "등록일",
        updatedAt: "수정일",
      },
      messages: {
        noSearchResults: "검색 결과가 없습니다.",
        loading: "로딩 중...",
        addSuccess: "코드가 성공적으로 추가되었습니다.",
        addFailed: "추가에 실패했습니다.",
        deleteConfirm: "코드를 삭제하시겠습니까?",
        deleteSuccess: "코드가 성공적으로 삭제되었습니다.",
        deleteFailed: "삭제에 실패했습니다.",
        editConfirm: "공통코드를 수정하시겠습니까?",
        editSuccess: "코드 정보가 성공적으로 수정되었습니다.",
        editFailed: "수정에 실패했습니다.",
      },
      editModal: {
        title: "코드 수정",
        codeNamePlaceholder: "코드명을 입력하세요",
        codeDescriptionPlaceholder: "코드 설명을 입력하세요",
        commonCodeGroupPlaceholder: "코드 그룹을 입력하세요",
        commonCodePlaceholder: "코드를 입력하세요",
      },
      options: {
        useYn: {
          Y: "사용",
          N: "미사용",
        },
      },
    },
  }, // Robot Group related messages
  robotGroup: {
    management: {
      title: "로봇 그룹 관리",
      actions: {
        addRobotGroup: "로봇 그룹 추가",
        editRobotGroup: "로봇 그룹 수정",
        deleteRobotGroup: "로봇 그룹 삭제",
        exportRobotGroup: "로봇 그룹 내보내기",
        actions: "작업",
      },
      search: {
        robotGrpId: "로봇 그룹 ID",
        siteId: "사이트 ID",
        robotGrpName: "로봇 그룹명",
        robotGrpTypeCd: "로봇 그룹 타입",
        adapterId: "어댑터 ID",
      },
      columns: {
        robotGrpId: "로봇 그룹 ID",
        siteId: "사이트 ID",
        robotGrpName: "로봇 그룹명",
        robotGrpTypeCd: "로봇 그룹 타입",
        adapterId: "어댑터 ID",
        createdAt: "등록일",
        updatedAt: "수정일",
      },
      messages: {
        noSearchResults: "검색 결과가 없습니다.",
        loading: "로딩 중...",
        addSuccess: "로봇 그룹이 성공적으로 추가되었습니다.",
        addFailed: "추가에 실패했습니다.",
        deleteConfirm: "로봇 그룹을 삭제하시겠습니까?",
        deleteSuccess: "로봇 그룹이 성공적으로 삭제되었습니다.",
        deleteFailed: "삭제에 실패했습니다.",
        editSuccess: "로봇 그룹 정보가 성공적으로 수정되었습니다.",
        editFailed: "수정에 실패했습니다.",
      },
      editModal: {
        title: "로봇 그룹 수정",
        robotGrpIdPlaceholder: "로봇 그룹 ID를 입력하세요",
        robotGrpNamePlaceholder: "로봇 그룹명을 입력하세요",
        robotGrpTypeCdPlaceholder: "로봇 그룹 타입을 입력하세요",
        adapterIdPlaceholder: "어댑터 ID를 입력하세요",
      },
    },
  },
  robot: {
    management: {
      title: "로봇 관리",
      actions: {
        addRobot: "로봇 추가",
        editRobot: "로봇 수정",
        deleteRobot: "로봇 삭제",
        exportRobot: "로봇 내보내기",
        actions: "작업",
      },
      search: {
        robotId: "로봇 ID",
        robotGrpId: "로봇 그룹 ID",
        robotName: "로봇명",
        robotTypeCd: "로봇 타입",
        siteId: "사이트 ID",
        useYn: "사용여부",
        robotModelId: "로봇 모델 ID",
        robotFmwVer: "펌웨어 버전",
        adpterId: "어댑터 ID",
      },
      columns: {
        robotId: "로봇 ID",
        robotGrpId: "로봇 그룹 ID",
        robotName: "로봇명",
        robotTypeCd: "로봇 타입",
        siteId: "사이트 ID",
        useYn: "사용여부",
        robotModelId: "로봇 모델 ID",
        robotFmwVer: "펌웨어 버전",
        adpterId: "어댑터 ID",
        createdAt: "등록일",
        updatedAt: "수정일",
      },
      messages: {
        noSearchResults: "검색 결과가 없습니다.",
        loading: "로딩 중...",
        addSuccess: "로봇이 성공적으로 추가되었습니다.",
        addFailed: "추가에 실패했습니다.",
        editConfirm: "로봇을 수정하시겠습니까?",
        deleteConfirm: "로봇을 삭제하시겠습니까?",
        deleteSuccess: "로봇이 성공적으로 삭제되었습니다.",
        deleteFailed: "삭제에 실패했습니다.",
        editSuccess: "로봇 정보가 성공적으로 수정되었습니다.",
        editFailed: "수정에 실패했습니다.",
      },
      editModal: {
        title: "로봇 수정",
        robotNamePlaceholder: "로봇명을 입력하세요",
        robotTypeCdPlaceholder: "로봇 타입을 입력하세요",
        robotModelIdPlaceholder: "로봇 모델 ID를 입력하세요",
        robotFmwVerPlaceholder: "펌웨어 버전을 입력하세요",
        adpterIdPlaceholder: "어댑터 ID를 입력하세요",
      },
      options: {
        useYn: {
          Y: "사용",
          N: "미사용",
        },
      },
      placeholders: {
        robotId: "로봇 ID를 입력하세요",
        robotGrpId: "로봇 그룹 ID를 입력하세요",
        robotName: "로봇명을 입력하세요",
        robotTypeCd: "로봇 타입을 입력하세요",
        siteId: "사이트를 선택하세요",
        useYn: "사용여부를 선택하세요",
        robotModelId: "로봇 모델 ID를 입력하세요",
        robotFmwVer: "펌웨어 버전을 입력하세요",
        adpterId: "어댑터 ID를 입력하세요",
      },
    },
  },
  // 맵 관리
  map: {
    management: {
      title: "맵 관리",
      actions: {
        actions: "작업",
      },
      search: {
        mapId: "맵 ID",
        siteId: "사이트 ID",
        mapName: "맵 이름",
        mapTypeCd: "맵 타입 코드",
        mapVer: "맵 버전",
        floor: "층수",
        createdBy: "생성자",
      },
      columns: {
        mapId: "맵 ID",
        siteId: "사이트 ID",
        mapName: "맵 이름",
        mapTypeCd: "맵 타입 코드",
        mapImgUrl: "맵 이미지 URL",
        mapImgBinr: "맵 이미지",
        imgSyncDt: "이미지 동기화 일시",
        mapVer: "맵 버전",
        floor: "층수",
        orgGlbX: "원점 글로벌 X",
        orgGlbY: "원점 글로벌 Y",
        orgLat: "원점 위도",
        orgLon: "원점 경도",
        rsltMtrPerPixel: "픽셀당 미터 결과",
        rsltLatPerPixel: "픽셀당 위도 결과",
        rsltLonPerPixel: "픽셀당 경도 결과",
        rotatDegree: "회전 각도",
        mapWidthLenMtr: "맵 가로 길이 (m)",
        mapHeightLenMtr: "맵 세로 길이 (m)",
        displayOrd: "표시 순서",
        createdBy: "생성자",
        createdAt: "생성일",
        updatedBy: "수정자",
        updatedAt: "수정일",
      },
      messages: {
        addSuccess: "맵이 성공적으로 추가되었습니다.",
        addFailed: "추가에 실패했습니다.",
        editSuccess: "맵 정보가 성공적으로 수정되었습니다.",
        editFailed: "수정에 실패했습니다.",
        deleteSuccess: "맵이 성공적으로 삭제되었습니다.",
        deleteFailed: "삭제에 실패했습니다.",
        deleteConfirm: "맵을 삭제하시겠습니까?",
        exportSuccess: "내보내기가 완료되었습니다.",
        exportError: "내보내기에 실패했습니다.",
        exportConfirm: "데이터를 내보내시겠습니까?",
      },
      editModal: {
        title: "맵 수정",
        mapIdPlaceholder: "맵 ID를 입력하세요",
        siteIdPlaceholder: "사이트 ID를 선택하세요",
        mapImgBinrPlaceholder: "맵 이미지 파일을 선택하세요",
        mapNamePlaceholder: "맵 이름을 입력하세요",
        mapTypeCdPlaceholder: "맵 타입 코드를 선택하세요",
        mapImgUrlPlaceholder: "맵 이미지 URL을 입력하세요",
        imgSyncDtPlaceholder: "이미지 동기화 일시를 입력하세요",
        mapVerPlaceholder: "맵 버전을 입력하세요",
        floorPlaceholder: "층수를 입력하세요",
        orgGlbXPlaceholder: "원점 글로벌 X를 입력하세요",
        orgGlbYPlaceholder: "원점 글로벌 Y를 입력하세요",
        orgLatPlaceholder: "원점 위도를 입력하세요",
        orgLonPlaceholder: "원점 경도를 입력하세요",
        rsltMtrPerPixelPlaceholder: "픽셀당 미터 결과를 입력하세요",
        rsltLatPerPixelPlaceholder: "픽셀당 위도 결과를 입력하세요",
        rsltLonPerPixelPlaceholder: "픽셀당 경도 결과를 입력하세요",
        rotatDegreePlaceholder: "회전 각도를 입력하세요",
        mapWidthLenMtrPlaceholder: "맵 가로 길이를 입력하세요",
        mapHeightLenMtrPlaceholder: "맵 세로 길이를 입력하세요",
        displayOrdPlaceholder: "표시 순서를 입력하세요",
      },
      addModal: {
        title: "맵 추가",
      },
      image: {
        noImage: "이미지 없음",
        clickToExpand: "클릭하여 확대",
        altText: "맵 이미지",
        defaultTitle: "맵 이미지",
        loadFailed: "이미지 로드 실패",
        loading: "이미지 로딩 중...",
        unsupportedType: "지원하지 않는 데이터 타입",
      },
    },
  },
  service: {
    button: {
      createService: "서비스 추가",
    },
    job: "Job",
    jobTitle: "로봇, 스테이션 그룹에서 이동시켜 작업을 배정하세요",
    robotCol: "로봇",
    stationCol: "스테이션",
    jobCol: "Job",
    selectTemplate: "서비스 템플릿 선택",
    selectInstance: "서비스 인스턴스 선택",
    title: "드래그 하거나 선택해서 Job 영역에 배치하세요.",
    title2: "Shift+클릭 시 다중 선택, Ctrl+클릭 시 개별 선택",
  },
  report: {
    alarmLog: {
      title: "로봇 알람 로그",
      search: "검색",
      columns: {
        datetime: "일시",
        robotName: "로봇명",
        alarmCode: "알람코드",
        alarmMessage: "알람메시지",
        status: "상태",
        priority: "우선순위",
        equipmentName: "장비명",
        robotGroupId: "로봇 그룹",
        description: "알람 설명",
        position: "위치",
        occurTime: "발생 시간",
        releaseTime: "릴리즈 시간",
      },
      filters: {
        robotName: "로봇명",
        alarmCode: "알람코드",
        status: "상태",
        all: "전체",
      },
      messages: {
        exportConfirm: "알람 로그를 엑셀로 다운로드 하시겠습니까?",
        searchPlaceholder: "로봇명 또는 알람코드로 검색",
        noData: "데이터가 없습니다",
        loading: "로딩 중...",
        dateRangeLimit: "리포트 다운로드를 위해 30일 이내의 날짜 범위를 선택해주세요.",
      },
    },
    serviceOrder: {
      title: "서비스 주문 리포트",
      search: "검색",
      orderType: "주문 유형",
      reportType: {
        header: "주문 헤더",
        detail: "주문 상세",
      },
      columns: {
        orderId: "주문 ID",
        serviceName: "서비스명​",
        orderType: "주문 유형",
        status: "상태",
        receiveDate: "수신일",
        startDate: "시작일",
        endDate: "종료일",
        sequence: "순서",
        jobType: "작업 유형",
        productCode: "제품 코드",
        location: "위치",
      },
      messages: {
        exportConfirm: "서비스 주문 로그를 내보내시겠습니까?",
        dateRangeLimit: "다운로드를 위한 날짜 범위는 30일을 초과할 수 없습니다.",
      },
    },
    serviceDashboard: {
      title: "서비스 대시보드",
      serviceOrder: "서비스 주문",
      todaysOrders: "오늘의 주문",
      rate: "비율",
      wait: "대기",
      run: "실행",
      complete: "완료",
      fail: "실패",
      product: "제품",
      totalJobs: "총 작업 수량",
      totalOrders: "전체 주문",
      status: "상태",
      total: "전체",
      columns: {
        serviceName: "서비스명",
        orderId: "주문 ID",
        startTime: "시작 시간",
        endTime: "종료 시간",
      },
    },
    monthlyReport: {
      title: "월간 리포트",
      totalJob: "총 작업 수",
      successRate: "성공률",
      avgUtil: "평균 가동률",
      totalRobots: "총 로봇 수",
      totalOperatingHours: "총 운행 시간",
      totalTasks: "총 작업 수",
      avgEfficiency: "평균 효율성",
      avgUtilization: "평균 가동률",
      dailyUsageChart: "일일 사용량 차트",
      robotTypeDistribution: "로봇 유형별 분포",
      robotSummary: "로봇 요약",
      serviceSummary: "서비스 요약",
      robotDetails: "로봇 상세 정보",
      export: "내보내기",
      exporting: "내보내는 중...",
      filters: {
        all: "전체",
      },
      label: {
        jobCount: "작업 수",
        totalJobCount: "총 작업 수",
        jobTime: "작업 시간",
        totalJobTime: "총 작업 시간",
        avgJobTime: "평균 작업 시간",
        dayOfMonth: "일",
        jobs: "건수",
      },
      columns: {
        totalJobCount: "총 작업 수",
        avgJobTime: "평균 작업 시간",
        serviceName: "서비스명",
        srvcInstcNm: "서비스 인스턴스명",
        successRate: "성공률",
        avgUtilization: "평균 가동률",
        errorCount: "오류 수",
        robotGroup: "로봇 그룹",
        robotCount: "로봇 수",
        alarmCount: "알람 발생",
        avgUptime: "평균 가동 시간",
        lastActivity: "마지막 활동",
        robotId: "로봇 ID",
        robotName: "로봇명",
        robotType: "로봇 유형",
        operatingHours: "운행 시간",
        tasksCompleted: "완료된 작업",
        efficiency: "효율성",
        lastMaintenance: "마지막 정비",
        status: "상태",
      },
      messages: {
        exportConfirm: "월간 리포트를 내보내시겠습니까?",
        exportSuccess: "내보내기가 완료되었습니다.",
        exportError: "내보내기에 실패했습니다. 나중에 다시 시도해 주세요.",
        fetchError: "데이터를 가져오는 데 실패했습니다. 나중에 다시 시도해 주세요.",
      },
    },
  },
  components: {
    searchFilter: {
      to: "~",
      defaultDescription: "이 목록에 대한 설명이 여기에 제공됩니다..",
    },
  },
  robotControl: {
    title: "로봇 제어",
    breadcrumb: {
      current: "Robot Control",
    },
    robotSelection: {
      placeholder: "Select Robot",
    },
    controlButtons: {
      run: "작동",
      stop: "중지",
      chargeOn: "충전연결",
      chargeOff: "충전해제",
      serviceStart: "서비스 시작",
      serviceStop: "서비스 중지",
      resume: "재개",
      pause: "일시정지",
      docking: "도킹",
      volume: "음량",
    },
    confirmMessages: {
      run: "로봇을 작동시키시겠습니까?",
      stop: "로봇을 중지시키시겠습니까?",
      chargeOn: "충전을 연결하시겠습니까?",
      chargeOff: "충전을 해제하시겠습니까?",
      serviceStart: "서비스를 시작하시겠습니까?",
      serviceStop: "서비스를 중지하시겠습니까?",
      resume: "로봇 작동을 재개하시겠습니까?",
      pause: "로봇을 일시 중지하시겠습니까?",
      docking: "로봇을 도킹하시겠습니까?",
    },
    activity: {
      tabs: {
        todayJobs: "오늘의 작업",
        todayAlarms: "오늘의 알람",
      },
      search: {
        placeholder: "검색어를 입력하세요",
      },
      table: {
        columns: {
          time: "시간",
          serviceName: "서비스 이름",
          jobName: "작업 이름",
          status: "상태",
          station: "스테이션",
        },
      },
    },
    utilizationChart: {
      title: "시간별 가동률",
      chartLabel: "가동",
    },
    robotInfo: {
      position: "현재 위치",
      connection: "통신 상태",
      destination: "목적지",
      jobProgress: "작업 상태",
      normal: "원활",
    },
    robotControlRight: {
      loadingMaps: "Loading maps...",
      loadingMapImage: "Loading map image...",
      mapArea: "지도 영역",
      noMapsAvailable: "No maps available",
      failedToLoadMapImage: "Failed to load map image",
      mapId: "Map ID",
    },
    orderDelivery: {
      title: "주문 및 배달",
      todayOrders: "오늘의 주문",
      date: "Date",
      hour: "시",
      pickup: "pickup",
      previous: "Previous",
      next: "Next",
    },
  },
  cafeOrder: {
    management: {
      title: "카페 주문 관리",
      badge: {
        paymentComplete: "결제 완료",
        orderReceived: "주문 접수",
        orderStarted: "주문 시작",
        pickupWaiting: "픽업 대기중",
        orderCompleted: "주문 완료",
        orderCanceled: "주문 취소",
        partialOrderCancel: "주문 일부 취소",
        orderPartialFail: "주문 일부 실패",
        orderFail: "주문 실패",
        orderUnknown: "알 수 없음",
      },
    },
    fields: {
      orderId: "주문 ID",
      householdName: "세대명",
      orderStatus: "주문 상태",
      rfCard: "RF카드",
      payCost: "결제 금액",
      totalCost: "총 금액",
      discountCost: "할인 금액",
      orderStartTime: "주문 시간",
      orderCompleteTime: "주문 완료 시간",
      odrCnclDt: "주문 취소 시간",
      odrCnclSrc: "취소자",
      odrCnclSrcUser: "주문 취소 원인 사용자",
      action: "작업",
      orderNo: "주문 번호",
    },
    actions: {
      detail: "상세보기",
      cancel: "취소",
      close: "닫기",
      cancelOrder: "주문 취소",
      retry: "재시도",
      confirm: "확인",
      orderCancel: "주문 취소",
    },
    modal: {
      orderDetail: "주문 상세",
    },
    status: {
      pending: "대기중",
    },
    messages: {
      failedToLoadDetails: "주문 상세 정보를 불러오는데 실패했습니다",
      noSearchResults: "검색 결과가 없습니다.",
      exportFailed: "내보내기에 실패했습니다.",
      exportSuccess: "내보내기가 완료되었습니다.",
      noData: "데이터가 없습니다.",
      invalidCancellationQuantity: "취소 수량을 선택해 주세요.",
    },
    auth: {
      title: "2단계 인증을 위한 비밀번호를 입력하세요",
      enterPassword: "비밀번호를 입력하세요",
      hidePassword: "비밀번호 숨기기",
      showPassword: "비밀번호 보기",
      success: "인증 성공",
      passwordRequired: "비밀번호는 필수 입력 항목입니다.",
    },
    detailCard: {
      detailNo: "주문 상세 번호",
      menuName: "메뉴명",
      optionName: "옵션명",
      productQty: "주문 수량",
      cnclQty: "취소 수량",
      unitPrice: "단가",
      totalPrice: "총 가격",
    },
  },
  household: {
    management: {
      title: "입주민 관리",
      actionsLabel: "작업",
      breadcrumbs: {
        cafeManagement: "카페 관리",
        householdManagement: "입주민 관리",
      },
      columns: {
        householdId: "ID",
        householdNm: "명",
        householdInfo: "정보",
        householdNickname: "닉네임",
        householdRfcardId: "RF카드 ID",
        siteId: "사이트 ID",
        adpterId: "어댑터 ID",
        useYn: "사용여부",
        createdAt: "생성일",
        updatedAt: "최근 수정 시간",
      },
      messages: {
        deleteConfirm: "입주민을 삭제하시겠습니까?",
        editConfirm: "이 입주민을 정말로 수정하시겠습니까?",
        noSearchResults: "검색 결과가 없습니다.",
        createSuccess: "입주민이 성공적으로 추가되었습니다.",
        createFailed: "추가에 실패했습니다.",
        editSuccess: "입주민 정보가 성공적으로 수정되었습니다.",
        editFailed: "수정에 실패했습니다.",
        deleteSuccess: "입주민이 성공적으로 삭제되었습니다.",
        deleteFailed: "삭제에 실패했습니다.",
        rfcardIdUpdated: "RFCard ID가 성공적으로 업데이트되었습니다.",
        updateFailed: "RFCard ID 업데이트에 실패했습니다.",
      },
      modalTitles: {
        add: "입주민 추가",
        edit: "입주민 수정",
        passwordRequired: "비밀번호 필요",
        editRfcardId: "RFCard ID 수정",
      },
      validation: {
        noChangesDetected: "변경 사항이 감지되지 않았습니다.",
        rfcardIdRequired: "RFCard ID는 필수입니다.",
      },
      placeholders: {
        householdId: "입주민 ID 입력",
        householdNm: "입주민 이름 입력",
        householdInfo: "입주민 정보 입력",
        householdNickname: "입주민 닉네임 입력",
        householdRfcardId: "입주민 RF카드 ID 입력",
        useYn: "사용 여부 선택",
        enterPassword: "비밀번호 입력",
        passwordPlaceholder: "비밀번호를 입력하세요",
        rfcardIdPlaceholder: "새 RF카드 ID 입력",
      },
    },
  },
  cafeOrderStats: {
    management: {
      title: "카페 달력",
      labels: {
        today: "오늘",
        showDetailOrders: "상세 주문 보기",
        netAmount: "순 매출",
        netOrders: "순 주문",
        netBeverages: "순 음료 수량",
        grossAmount: "총 매출",
        grossOrders: "총 주문",
        grossBeverages: "총 음료 수량",
        totalRevenue: "총 매출",
        totalAmount: "총 판매",
        totalOrders: "총 주문",
        totalBeverages: "총 음료 수량",
        canceledAmount: "취소된 금액",
        canceledOrders: "취소된 주문",
        canceledBeverages: "취소된 음료 수량",
        canceledQuantity: "취소된 수량",
        revenue: "매출",
        orders: "주문",
        order: "주문",
        beverage: "음료",
        beverages: "음료",
        cancel: "취소",
        daily: "일일",
        weekly: "주간",
        calendar: "달력",
        chart: "차트",
        amount: "금액",
        quantity: "수량",
        displayedDay: "범위 내 일: { displayedDays } / 7일",
        displayedDays: "범위 내 일: { displayedDays } / 7일",
      },
      units: {
        order: "건",
        orders: "건",
        beverage: "개",
        beverages: "개",
      },
    },
    buttons: {
      retry: "재시도",
      detail: "상세보기",
    },
    messages: {
      failedToLoadStatistics: "통계 데이터를 불러오는 데 실패했습니다",
      loadingStatistics: "통계 데이터를 불러오는 중...",
      noDataAvailable: "사용 가능한 데이터가 없습니다",
      noDataForPeriod: "해당 기간에 대한 주문 데이터가 없습니다",
      cancelSuccess: "주문이 성공적으로 취소되었습니다.",
    },
    errors: {
      invalidOrderId: "유효하지 않은 주문 ID입니다",
      invalidStatisticsParams: "유효하지 않은 통계 매개변수입니다",
      loadError: "데이터를 불러올 수 없습니다",
      loadFailed: "통계 데이터를 불러오는 데 실패했습니다",
      noItemsSelected: "선택된 항목이 없습니다",
      passwordRequired: "비밀번호는 필수 입력 항목입니다",
      cancelFailed: "취소에 실패했습니다.",
    },
  },
  executeService: {
    fields: {
      odrExecNm: "실행명",
      srvcInstcNm: "서비스명",
      execTypeCd: "실행 타입",
      strtDt: "시작 일시",
      endDt: "만료 일시",
      robotName: "로봇명",
      serviceTime: "서비스 시간",
      stnNameList: "스테이션 순서",
      zoneNameList: "존 순서",
      execCycleMn: "주기 (분)",
      lastExecDt: "마지막 실행 일시",
      useYn: "활성화",
      actions: "작업",
    },
    composable: {
      noData: "데이터 없음",
      unnamedRoute: "명명되지 않은 경로",
    },
    options: {
      useYn: {
        all: "전체",
        yes: "활성화",
        no: "비활성화",
      },
      all: "전체",
    },
    messages: {
      createSuccess: "서비스 실행이 성공적으로 추가되었습니다.",
      createFailed: "추가에 실패했습니다.",
      updateSuccess: "서비스 실행이 성공적으로 수정되었습니다.",
      updateFailed: "수정에 실패했습니다.",
      deleteConfirm: "서비스 실행을 삭제하시겠습니까?",
      deleteSuccess: "서비스 실행이 성공적으로 삭제되었습니다.",
      deleteFailed: "삭제에 실패했습니다.",
    },
    modal: {
      createTitle: "서비스 실행 추가",
      editTitle: "서비스 실행 수정",
      step1: "단계 1",
      step2: "단계 2",
      selectZone: "존 선택",
      selectedZones: "선택된 존:",
      sections: {
        basic: "기본 정보",
        robot: "로봇 설정",
        location: "위치 설정",
        time: "시간 설정",
        advanced: "고급 설정",
        detail: "세부 설정",
      },
      fields: {
        scheduleName: "스케줄명",
        scheduleNamePlaceholder: "스케줄명을 입력하세요",
        serviceGroup: "서비스 그룹",
        serviceGroupPlaceholder: "서비스 그룹 선택",
        serviceInstance: "서비스 인스턴스",
        serviceInstancePlaceholder: "서비스 인스턴스 선택",
        robot: "로봇",
        robotPlaceholder: "로봇 선택",
        locationType: "위치 타입",
        route: "경로",
        routePlaceholder: "경로 선택",
        zone: "존",
        zonePlaceholder: "존 선택",
        timeType: "시간 타입",
        reserve: "예약",
        now: "즉시",
        executeDate: "실행 날짜",
        executeTime: "실행 시간",
        period: "주기",
        periodPlaceholder: "주기 입력",
        periodUnit: "단위",
        minute: "분",
        hour: "시간",
        minuteConfirm: "분",
        hourConfirm: "시간",
        dayConfirm: "일",
        secondConfirm: "초",
        day: "일",
        cycleEnabled: "반복 횟수 사용",
        cyclePeriod: "반복 횟수",
        cyclePeriodPlaceholder: "반복 횟수 입력",
        stayTimeEnabled: "대기 시간 사용",
        stayTime: "대기 시간",
        stayTimePlaceholder: "대기 시간 입력",
        expired: "만료일 설정",
        expireDate: "만료일",
        active: "활성화",
        daySelectable: "요일 선택",
        selectedDays: "선택된 요일",
        actions: "작업",
      },
      tabs: {
        once: "1회 실행",
        repeat: "반복 실행",
      },
      days: {
        monday: "월요일",
        tuesday: "화요일",
        wednesday: "수요일",
        thursday: "목요일",
        friday: "금요일",
        saturday: "토요일",
        sunday: "일요일",
        mon: "월",
        tue: "화",
        wed: "수",
        thu: "목",
        fri: "금",
        sat: "토",
        sun: "일",
      },
      buttons: {
        previous: "이전",
        next: "다음",
        cancel: "취소",
        confirm: "확인",
        create: "생성",
        update: "수정",
        back: "뒤로",
        reset: "초기화",
      },
      validation: {
        scheduleNameRequired: "스케줄명을 입력하세요",
        serviceGroupRequired: "서비스 그룹을 선택하세요",
        serviceInstanceRequired: "서비스 인스턴스를 선택하세요",
        robotRequired: "로봇을 선택하세요",
        locationRequired:
          "선택한 로봇 유형이 위치 유형과 일치하지 않습니다. PATROL 로봇의 경우 경로를 선택하세요. CLEANING 로봇의 경우 존을 선택하세요.",
        routeRequired: "경로를 선택하세요",
        zoneRequired: "최소 1개의 존을 선택하세요",
        periodRequired: "주기를 입력하세요",
        periodInvalid: "유효한 주기를 입력하세요",
        cyclePeriodInvalid: "유효한 반복 횟수를 입력하세요",
        stayTimeInvalid: "유효한 대기 시간을 입력하세요",
        dayRequired: "최소 1개의 요일을 선택하세요",
        expireDateInvalid: "만료일은 시작일보다 이후여야 합니다",
      },
      placeholders: {
        selectExecutionDate: "실행 날짜 선택",
        selectExpireDate: "만료 날짜 선택",
        selectServiceStartTime: "시작 시간",
        selectServiceEndTime: "종료 시간",
      },
      labels: {
        now: "즉시",
        period: "주기",
        minutes: "분",
        seconds: "초",
        second: "초",
        secondConfirm: "초",
        hour: "시간",
        days: "일",
        expired: "만료",
        setDay: "요일 설정",
        cycle: "반복 횟수",
        times: "회",
        time: "회",
        stayTime: "대기 시간",
        active: "활성화",
        serviceTime: "서비스 시간",
        serviceStartTime: "서비스 시작 시간",
        serviceEndTime: "서비스 종료 시간",
      },
      confirmation: {
        title: "서비스 실행 확인",
        subtitle: "다음 내용으로 스케줄을 생성/수정하시겠습니까?",
        sections: {
          basicInformation: "기본 정보",
          robotLocation: "로봇 & 위치",
          timeSettings: "시간 설정",
          additionalSettings: "추가 설정",
          detail: "세부 설정",
        },
        labels: {
          scheduleName: "스케줄명",
          serviceGroup: "서비스 그룹",
          serviceInstance: "서비스 인스턴스",
          scheduleType: "스케줄 타입",
          robot: "로봇",
          locationType: "위치 타입",
          location: "위치",
          timeType: "시간 타입",
          executeDate: "실행 날짜",
          period: "주기",
          serviceTime: "서비스 시간",
          serviceStartTime: "서비스 시작 시간",
          serviceEndTime: "서비스 종료 시간",
          expireDate: "만료일",
          selectedDays: "선택된 요일",
          cycle: "반복 횟수",
          stayTime: "대기 시간",
          active: "활성화",
        },
        yes: "예",
        no: "아니오",
      },
    },
  },
  telephone: {
    management: {
      title: "전화번호 매핑",
      actions: {
        addTelephone: "전화번호 추가",
        editTelephone: "전화 편집",
        deleteTelephone: "전화 삭제",
        deleteSelected: "선택한 항목 삭제",
        bulkDelete: "일괄 삭제",
        export: "내보내다",
        actions: "행위",
      },
      actionsLabel: "행위",
      columns: {
        cttTelNo: "연락처 전화번호",
        roleName: "역할 이름",
        cttTelDesc: "전화 설명",
        siteId: "사이트 ID",
        siteName: "사이트 이름",
        useYn: "사용 상태",
        createdAt: "제작일",
        updatedAt: "업데이트됨",
        startTime: "시작 시간",
        endTime: "종료 시간",
        availableTime: "수신 시간",
        cttPlanDay: "수신 요일",
        setDay: "수신 요일 설정",
      },
      placeholders: {
        cttTelNo: "연락처 전화번호를 입력하세요",
        siteId: "사이트 선택",
        roleId: "역할 선택",
        cttTelDesc: "연락처 전화번호 설명을 입력하세요",
        useYn: "사용 여부를 선택하세요(예/아니오).",
      },
      labels: {
        setTime: "수신 시간 설정",
        always: "항상",
      },
      modalTitles: {
        add: "전화번호 추가",
        edit: "전화번호 수정",
      },
      messages: {
        createSuccess: "전화번호가 성공적으로 추가되었습니다.",
        createFailed: "추가에 실패했습니다.",
        editSuccess: "전화번호 정보가 성공적으로 수정되었습니다.",
        editFailed: "수정에 실패했습니다.",
        deleteConfirm: "전화번호를 삭제하시겠습니까?",
        deleteFailed: "삭제에 실패했습니다.",
        confirmDeleteLinked: "현재 사용 중인 전화번호입니다. 삭제하시겠습니까?",
        deleteSuccess: "전화번호가 성공적으로 삭제되었습니다.",
      },
    },
    validation: {
      selectAtLeastOne: "요일을 최소 하나 선택하세요",
      startTimeEqualEndTime: "시작 시간과 종료 시간이 같아서는 안 됩니다.",
    },
    messages: {
      deleteConfirm: "전화번호를 삭제하시겠습니까?",
      noSearchResults: "검색 결과가 없습니다.",
      createSuccess: "전화번호가 성공적으로 추가되었습니다.",
      createFailed: "추가에 실패했습니다.",
      editSuccess: "전화번호 정보가 성공적으로 수정되었습니다.",
      editFailed: "수정에 실패했습니다.",
      deleteSuccess: "연락처 전화번호가 성공적으로 삭제되었습니다.",
      deleteFailed: "삭제에 실패했습니다.",
      invalidPhoneLength: "전화번호는 최소 {min}자리에서 최대 {max}자리 사이여야 합니다.",
    },
  },
  alarmRoleMapping: {
    title: "알람 역할 매핑",
    label: {
      site: "사이트",
      adapterName: "어댑터 이름",
      role: "역할",
      phoneNumber: "전화번호",
      selectAlarm: "알람 선택",
      other: "기타",
      others: "기타",
      active: "사용",
      inactive: "미사용",
    },
    columns: {
      adapterName: "어댑터 이름",
      alarmName: "알람 이름",
      alarmLevel: "알람 레벨",
      siteId: "사이트 ID",
      siteName: "사이트명",
      useYn: "사용여부",
      active: "활성화",
      roleId: "역할 ID",
      roleName: "역할명",
      phoneNumber: "전화번호",
      action: "액션",
    },
    filters: {
      adapterName: "어댑터 이름",
      alarmName: "알람 이름",
      alarmLevel: "알람 레벨",
      roleId: "역할 ID",
      activeStatus: "활성화 상태",
    },
    levels: {
      info: "정보",
      warning: "경고",
      error: "오류",
      critical: "긴급",
    },
    roles: {
      admin: "관리자",
      developer: "개발자",
    },
    status: {
      active: "활성화",
      inactive: "비활성화",
    },
    modal: {
      createTitle: "알람 역할 추가",
      editTitle: "알람 역할 수정",
    },
    adapterDetails: {
      title: "어댑터 알람 상세",
      tableTitle: "알람 목록",
      viewButton: "상세 보기",
      selectButton: "선택",
      moreButton: "더보기",
      quickView: "선택된 알람 정보",
      alarmCode: "알람 코드",
      description: "설명",
      helperText: "어댑터를 선택한 후 상세 보기 버튼을 클릭하세요",
      selectedCount: "{count}개 선택됨",
      searchPlaceholder: "알람 이름, 코드 또는 설명 검색...",
    },
    placeholders: {
      adapter: "어댑터 이름을 입력하세요",
      alarm: "알람 이름을 입력하세요",
      site: "사이트 이름을 입력하세요",
      role: "선택안함",
      phoneNumber: "선택안함",
    },
    messages: {
      createSuccess: "알람 역할이 성공적으로 추가되었습니다.",
      createFailed: "추가에 실패했습니다.",
      updateSuccess: "알람 역할 정보가 성공적으로 수정되었습니다.",
      updateFailed: "수정에 실패했습니다.",
      deleteSuccess: "알람 역할이 성공적으로 삭제되었습니다.",
      deleteFailed: "삭제에 실패했습니다.",
      deleteConfirm: "알람 역할을 삭제하시겠습니까?",
      fetchError: "알람 역할 매핑 조회 중 오류가 발생했습니다.",
      roleOrPhoneRequired: "최소한 하나의 연락처(역할 또는 전화번호)가 필요합니다.",
      alarmCodeRequired: "최소한 1개의 알람 코드를 선택해야 합니다.",
      siteRequired: "사이트를 선택해주세요.",
      adapterRequired: "어댑터를 선택해주세요.",
      emptyPayload: "제출할 데이터가 없습니다. 최소한 1개의 알람 코드를 추가해주세요.",
      siteMaxLength: "사이트 ID는 최대 {max}자까지 입력할 수 있습니다.",
      adapterMaxLength: "어댑터 ID는 최대 {max}자까지 입력할 수 있습니다.",
      alarmCodeMaxLength: "알람 코드는 최대 {max}자까지 입력할 수 있습니다.",
      roleMaxLength: "역할 ID는 최대 {max}자까지 입력할 수 있습니다.",
      phoneMaxLengthTotal: "전화번호 전체 길이는 최대 {max}자까지 입력할 수 있습니다.",
      groupExistsConfirm:
        "어댑터: '{adapterName}'에 '{contact}' 연락처의 알람 그룹이 이미 존재합니다 (상태: {useYn}). 선택한 알람이 이 그룹에 추가됩니다. 동의하시겠습니까?",
      groupExistsConfirmNoContact:
        "어댑터: '{adapterName}'에 알람 그룹이 이미 존재합니다 (상태: {useYn}). 선택한 알람이 이 그룹에 추가됩니다. 동의하시겠습니까?",
    },
    validation: {
      adapterNameRequired: "어댑터 이름을 입력해주세요.",
      alarmNameRequired: "알람 이름을 입력해주세요.",
      alarmLevelRequired: "알람 레벨을 선택해주세요.",
      siteIdRequired: "사이트 ID를 입력해주세요.",
      roleIdRequired: "역할 ID를 입력해주세요.",
      phoneNumberRequired: "전화번호를 입력해주세요.",
    },
  },
  timePicker: {
    labels: {
      hour: "시",
      minute: "분",
    },
  },
};
